module.exports = __webpack_public_path__ + "media/images/hello-goodness--compressed-42826e9941b3153d0702737e66d476ff.png";